import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <rect
                x='3.9'
                y='3.9'
                width='10.8'
                height='3.6'
                rx='1.35'
                fill='transparent'
                stroke='currentColor'
                strokeWidth='1.8'
            />
            <path
                d='M3.9 11.55C3.9 10.8044 4.50442 10.2 5.25 10.2H18.75C19.4956 10.2 20.1 10.8044 20.1 11.55V12.45C20.1 13.1956 19.4956 13.8 18.75 13.8H5.25C4.50442 13.8 3.9 13.1956 3.9 12.45V11.55Z'
                fill='transparent'
                stroke='currentColor'
                strokeWidth='1.8'
            />
            <rect
                x='9.30015'
                y='16.5001'
                width='10.8'
                height='3.6'
                rx='1.35'
                fill='transparent'
                stroke='currentColor'
                strokeWidth='1.8'
            />
        </SvgIcon>
    );
});
